const StatusAplicacaoLevantamentoEnum = {
    NAO_INICIADO: 'NAO_INICIADO',
    EM_ANDAMENTO: 'EM_ANDAMENTO',
    FINALIZADO: 'FINALIZADO'
}


export default StatusAplicacaoLevantamentoEnum;
